import { ReactNode } from 'react';
import { IAsset } from '@desp-aas/desp-ui-fwk';
import AssetCardNewDetailed from '../AssetCardNew/AssetCardNewDetailed';
import AssetCardNewDetailedLoading from '../AssetCardNew/AssetCardNewDetailedLoading';

export type IProfileAssets = {
    [assetType: string]: IAsset[]
}

type IProps = {
    title: ReactNode
    type: string
    assets: IProfileAssets
    loading?: boolean
}

export const UserProfileAssets = (props: IProps) => {
    if(props.loading) return <LoadingUserProfileAssets title={props.title}/>
    return (
        <div className="user-profile-asset">
            <h2>{props.title}</h2>
            <div className="user-profile-asset-list">
                {
                    props.assets && props.type in props.assets &&  props.assets[props.type].length > 0
                        ?
                        props.assets[props.type].map((asset) => (
                            <AssetCardNewDetailed
                                asset={asset}
                                key={asset.id}
                            />
                        ))
                        :
                        <div className="no-data">
                            No {props.title} yet.
                        </div>
                }
            </div>
        </div>
    )
}

function LoadingUserProfileAssets(props: { title: ReactNode }) {
    return (
        <div className="loading-user-profile-asset">
            <h2>{props.title}</h2>
            <div className="loading-user-profile-asset-list">
                <AssetCardNewDetailedLoading/>
                <AssetCardNewDetailedLoading/>
            </div>
        </div>
    )
}
